/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Rdd(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M18 21H6C4.343 21 3 19.657 3 18V6C3 4.343 4.343 3 6 3H18C19.657 3 21 4.343 21 6V18C21 19.657 19.657 21 18 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.0909V9H7.00852C7.39299 9 7.72112 9.06877 7.9929 9.20632C8.26634 9.34221 8.47431 9.53527 8.61683 9.78551C8.76101 10.0341 8.8331 10.3266 8.8331 10.663C8.8331 11.0011 8.76018 11.2919 8.61435 11.5355C8.46851 11.7775 8.25722 11.9631 7.98047 12.0923C7.70537 12.2216 7.37228 12.2862 6.98118 12.2862H5.63636V11.4212H6.80717C7.01267 11.4212 7.18336 11.393 7.31925 11.3366C7.45514 11.2803 7.55623 11.1958 7.62251 11.0831C7.69046 10.9704 7.72443 10.8304 7.72443 10.663C7.72443 10.494 7.69046 10.3514 7.62251 10.2354C7.55623 10.1194 7.45431 10.0316 7.31676 9.97195C7.18087 9.91063 7.00935 9.87997 6.8022 9.87997H6.07635V14.0909H5ZM7.74929 11.7741L9.01456 14.0909H7.82635L6.58842 11.7741H7.74929Z"
        fill={color}
      />
      <path
        d="M11.3984 14.0909H9.59375V9H11.4134C11.9254 9 12.3662 9.10192 12.7358 9.30575C13.1054 9.50793 13.3896 9.79877 13.5884 10.1783C13.7889 10.5578 13.8892 11.0118 13.8892 11.5405C13.8892 12.0708 13.7889 12.5265 13.5884 12.9077C13.3896 13.2888 13.1037 13.5813 12.7308 13.7852C12.3596 13.989 11.9155 14.0909 11.3984 14.0909ZM10.6701 13.1687H11.3537C11.6719 13.1687 11.9395 13.1123 12.1566 12.9996C12.3754 12.8853 12.5394 12.7088 12.6488 12.4702C12.7598 12.2299 12.8153 11.92 12.8153 11.5405C12.8153 11.1643 12.7598 10.8569 12.6488 10.6183C12.5394 10.3796 12.3762 10.204 12.1591 10.0913C11.942 9.97857 11.6744 9.92223 11.3562 9.92223H10.6701V13.1687Z"
        fill={color}
      />
      <path
        d="M16.4912 14.0909H14.6865V9H16.5061C17.0182 9 17.459 9.10192 17.8286 9.30575C18.1981 9.50793 18.4823 9.79877 18.6812 10.1783C18.8817 10.5578 18.982 11.0118 18.982 11.5405C18.982 12.0708 18.8817 12.5265 18.6812 12.9077C18.4823 13.2888 18.1965 13.5813 17.8236 13.7852C17.4524 13.989 17.0083 14.0909 16.4912 14.0909ZM15.7629 13.1687H16.4465C16.7646 13.1687 17.0323 13.1123 17.2494 12.9996C17.4681 12.8853 17.6322 12.7088 17.7416 12.4702C17.8526 12.2299 17.9081 11.92 17.9081 11.5405C17.9081 11.1643 17.8526 10.8569 17.7416 10.6183C17.6322 10.3796 17.469 10.204 17.2519 10.0913C17.0348 9.97857 16.7671 9.92223 16.449 9.92223H15.7629V13.1687Z"
        fill={color}
      />
    </svg>
  );
}

Rdd.defaultProps = {
  color: "currentColor",
  size: 24,
};

Rdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
